"use client";
import { jsx as t, jsxs as n, Fragment as l } from "react/jsx-runtime";
import { Shadow as F, RootProvider as u, WebWidgetInteractionType as g, EmbeddedChat as e, useModal as p, useWidget as A, dataAttr as d, Modal as b, PortalWithTheme as s } from "@inkeep/cxkit-styled";
import { Fragment as m } from "react";
import { WidgetToggle as M } from "./widget-toggle.js";
import { ModalContent as I } from "./modal.js";
function $(a) {
  const { baseSettings: r, aiChatSettings: c } = a;
  return /* @__PURE__ */ t(
    F,
    {
      wrapperStyles: {
        height: "inherit",
        width: "inherit"
      },
      children: /* @__PURE__ */ t(
        u,
        {
          config: {
            baseSettings: r,
            aiChatSettings: c
          },
          componentType: g.EmbeddedChat,
          children: /* @__PURE__ */ t(k, { ...a })
        }
      )
    }
  );
}
function C(a) {
  const { children: r, onToggleView: c, isHidden: o, shouldAutoFocusInput: i = !c } = a;
  return /* @__PURE__ */ t(e.Provider, { isHidden: o, shouldAutoFocusInput: i, children: r });
}
function k(a) {
  return /* @__PURE__ */ t(C, { ...a, children: /* @__PURE__ */ t(T, { ...a }) });
}
function T(a) {
  const { onToggleView: r } = a, c = p(), o = A();
  return /* @__PURE__ */ t(c && !o ? I : m, { children: /* @__PURE__ */ n(
    e.Wrapper,
    {
      variant: r ? "no-shadow" : "container-with-shadow",
      "data-composite": d(!!a.onToggleView || c?.isOpen),
      children: [
        /* @__PURE__ */ t(e.ConversationLoading, {}),
        /* @__PURE__ */ n(e.Root, { children: [
          /* @__PURE__ */ t(B, { ...a }),
          /* @__PURE__ */ t(S, {}),
          /* @__PURE__ */ t(L, {})
        ] }),
        /* @__PURE__ */ t(W, {}),
        /* @__PURE__ */ t(P, {})
      ]
    }
  ) });
}
function B(a) {
  const { onToggleView: r, askAILabel: c, searchLabel: o } = a, i = !!r;
  return /* @__PURE__ */ n(e.Header, { "data-show-toolbar": d(i), children: [
    i && /* @__PURE__ */ n(e.HeaderToolbar, { children: [
      /* @__PURE__ */ n(e.HeaderToolbarWrapper, { children: [
        /* @__PURE__ */ t(e.ToolbarHeader, {}),
        /* @__PURE__ */ n(e.Disclaimer, { children: [
          /* @__PURE__ */ t(e.DisclaimerTrigger, {}),
          /* @__PURE__ */ n(e.DisclaimerContent, { side: "bottom", align: "start", children: [
            /* @__PURE__ */ t(e.DisclaimerText, {}),
            /* @__PURE__ */ t(e.DisclaimerArrow, {})
          ] })
        ] })
      ] }),
      /* @__PURE__ */ t(
        M,
        {
          onToggleView: r,
          askAILabel: c,
          searchLabel: o,
          view: "chat"
        }
      )
    ] }),
    /* @__PURE__ */ t(b.Close, {})
  ] });
}
function S() {
  return /* @__PURE__ */ t(e.Content, { children: /* @__PURE__ */ n(e.ContentScrollArea, { children: [
    /* @__PURE__ */ t(e.ContentScrollAreaViewport, { children: /* @__PURE__ */ t(v, {}) }),
    /* @__PURE__ */ t(e.ContentScrollAreaScrollbar, { children: /* @__PURE__ */ t(e.ContentScrollAreaThumb, {}) }),
    /* @__PURE__ */ t(e.ContentScrollAreaCorner, {})
  ] }) });
}
function v() {
  return /* @__PURE__ */ t(e.Messages, { children: ({ messages: a }) => /* @__PURE__ */ n(l, { children: [
    /* @__PURE__ */ t(x, {}),
    a.map((r) => /* @__PURE__ */ n(e.MessageWrapper, { message: r, children: [
      /* @__PURE__ */ t(w, {}),
      /* @__PURE__ */ t(e.MessageLoading, {}),
      /* @__PURE__ */ n(e.MessageContentWrapper, { children: [
        /* @__PURE__ */ t(e.MessageContent, { children: /* @__PURE__ */ t(e.Message, {}) }),
        /* @__PURE__ */ t(H, {}),
        /* @__PURE__ */ t(f, {}),
        /* @__PURE__ */ t(y, {})
      ] })
    ] }, r.id))
  ] }) });
}
function x() {
  return /* @__PURE__ */ n(e.IntroMessageWrapper, { children: [
    /* @__PURE__ */ n(e.MessageHeader, { children: [
      /* @__PURE__ */ t(e.MessageAvatar, { children: /* @__PURE__ */ n(e.MessageAvatarContent, { children: [
        /* @__PURE__ */ t(e.MessageAvatarFallback, {}),
        /* @__PURE__ */ t(e.MessageAvatarImage, {})
      ] }) }),
      /* @__PURE__ */ t(e.MessageName, {})
    ] }),
    /* @__PURE__ */ n(e.MessageContentWrapper, { children: [
      /* @__PURE__ */ t(e.MessageContent, { children: /* @__PURE__ */ t(e.Message, {}) }),
      /* @__PURE__ */ n(e.Disclaimer, { children: [
        /* @__PURE__ */ t(e.DisclaimerLabel, {}),
        /* @__PURE__ */ t(e.DisclaimerTrigger, {}),
        /* @__PURE__ */ n(e.DisclaimerContent, { children: [
          /* @__PURE__ */ t(e.DisclaimerText, {}),
          /* @__PURE__ */ t(e.DisclaimerArrow, {})
        ] })
      ] }),
      /* @__PURE__ */ n(e.ExampleQuestions, { children: [
        /* @__PURE__ */ t(e.ExampleQuestionsLabel, {}),
        /* @__PURE__ */ t(e.ExampleQuestionsList, { children: (a) => a.map((r) => /* @__PURE__ */ t(e.ExampleQuestion, { children: /* @__PURE__ */ t(e.ExampleQuestionButton, { question: r }) }, r)) })
      ] })
    ] })
  ] });
}
function w() {
  return /* @__PURE__ */ n(e.MessageHeader, { children: [
    /* @__PURE__ */ t(e.MessageAvatar, { children: /* @__PURE__ */ n(e.MessageAvatarContent, { children: [
      /* @__PURE__ */ t(e.MessageAvatarFallback, {}),
      /* @__PURE__ */ t(e.MessageAvatarImage, {})
    ] }) }),
    /* @__PURE__ */ t(e.MessageName, {})
  ] });
}
function H() {
  return /* @__PURE__ */ n(e.MessageAttachments, { children: [
    /* @__PURE__ */ t(e.MessageAttachmentsList, { children: (a) => a.map((r) => /* @__PURE__ */ n(e.MessageAttachmentsItem, { attachment: r, children: [
      /* @__PURE__ */ t(e.MessageAttachmentsItemIcon, {}),
      /* @__PURE__ */ t(e.MessageAttachmentsItemTitle, {})
    ] }, r.id)) }),
    /* @__PURE__ */ t(e.MessageAttachmentsPreview, { children: /* @__PURE__ */ t(s, { children: /* @__PURE__ */ t(e.MessageAttachmentsPreviewOverlay, { children: /* @__PURE__ */ n(e.MessageAttachmentsPreviewContent, { children: [
      /* @__PURE__ */ t(e.MessageAttachmentsPreviewHeader, {}),
      /* @__PURE__ */ t(e.MessageAttachmentsPreviewClose, {}),
      /* @__PURE__ */ t(e.MessageAttachmentsPreviewBody, {})
    ] }) }) }) })
  ] });
}
function f() {
  return /* @__PURE__ */ n(e.MessageToolbar, { children: [
    /* @__PURE__ */ t(e.MessageToolActions, { children: (a) => a.map((r, c) => /* @__PURE__ */ t(e.MessageToolAction, { action: r }, `action-${c}`)) }),
    /* @__PURE__ */ t(e.MessageAction, { action: "copy" }),
    /* @__PURE__ */ t(e.MessageAction, { action: "upvote" }),
    /* @__PURE__ */ t(e.MessageAction, { action: "downvote" })
  ] });
}
function y() {
  return /* @__PURE__ */ n(e.MessageSources, { children: [
    /* @__PURE__ */ t(e.MessageSourcesHeader, {}),
    /* @__PURE__ */ t(e.MessageSourcesList, { children: (a) => a.map((r, c) => /* @__PURE__ */ n(e.MessageSourceItem, { href: r.url, source: r, children: [
      /* @__PURE__ */ t(e.MessageSourceItemBreadcrumbs, { children: r.breadcrumbs?.map((o) => /* @__PURE__ */ n(m, { children: [
        o,
        /* @__PURE__ */ t(e.MessageSourceItemBreadcrumbIcon, {})
      ] }, o)) }),
      /* @__PURE__ */ t(e.MessageSourceItemIcon, {}),
      /* @__PURE__ */ t(e.MessageSourceItemTitle, {}),
      /* @__PURE__ */ t(e.MessageSourceItemTag, {}),
      /* @__PURE__ */ t(e.MessageSourceItemDescription, { children: (o) => o.map((i, h) => /* @__PURE__ */ t(
        e.MessageSourceItemDescriptionPart,
        {
          part: i
        },
        `part-${h}`
      )) }),
      /* @__PURE__ */ t(e.MessageSourceItemIndicator, {})
    ] }, c)) })
  ] });
}
function L() {
  return /* @__PURE__ */ n(e.Footer, { children: [
    /* @__PURE__ */ t(D, {}),
    /* @__PURE__ */ t(E, {})
  ] });
}
function D() {
  return /* @__PURE__ */ n(e.InputFieldset, { children: [
    /* @__PURE__ */ n(e.InputGroup, { children: [
      /* @__PURE__ */ t(e.Input, {}),
      /* @__PURE__ */ t(e.SendButton, { children: /* @__PURE__ */ t(e.SendButtonIcon, {}) })
    ] }),
    /* @__PURE__ */ n(e.AttachmentsBar, { children: [
      /* @__PURE__ */ t(e.AttachmentsBarList, { children: (a) => a.map((r) => /* @__PURE__ */ n(e.AttachmentsBarAttachment, { attachment: r, children: [
        /* @__PURE__ */ t(e.AttachmentsBarAttachmentIcon, {}),
        /* @__PURE__ */ t(e.AttachmentsBarAttachmentTitle, {}),
        /* @__PURE__ */ t(e.AttachmentsBarAttachmentDelete, {})
      ] }, r.id)) }),
      /* @__PURE__ */ n(e.AttachmentsBarActions, { children: [
        /* @__PURE__ */ n(e.AttachmentsBarInfoTip, { children: [
          /* @__PURE__ */ t(e.AttachmentsBarInfoTipIcon, {}),
          /* @__PURE__ */ t(e.AttachmentsBarInfoTipText, {})
        ] }),
        /* @__PURE__ */ t(e.AttachmentsBarInputs, { children: (a) => a.map((r) => /* @__PURE__ */ n(e.AttachmentsBarInput, { input: r, children: [
          /* @__PURE__ */ t(e.AttachmentsBarInputIcon, {}),
          r.displayName
        ] }, r.id)) })
      ] }),
      /* @__PURE__ */ t(s, { children: /* @__PURE__ */ t(e.AttachmentsBarModal, { children: /* @__PURE__ */ t(e.AttachmentsBarModalOverlay, { children: /* @__PURE__ */ n(e.AttachmentsBarModalContent, { children: [
        /* @__PURE__ */ n(e.AttachmentsBarModalHeader, { children: [
          /* @__PURE__ */ t(e.AttachmentsBarModalHeading, {}),
          /* @__PURE__ */ t(e.AttachmentsBarModalDescription, {}),
          /* @__PURE__ */ t(e.AttachmentsBarModalHelp, {})
        ] }),
        /* @__PURE__ */ t(e.AttachmentsBarModalClose, {}),
        /* @__PURE__ */ t(e.AttachmentsBarModalBody, { children: /* @__PURE__ */ n(e.AttachmentsBarForm, { children: [
          /* @__PURE__ */ n(e.AttachmentsBarFormTitle, { children: [
            /* @__PURE__ */ t(e.AttachmentsBarFormTitleLabel, {}),
            /* @__PURE__ */ t(e.AttachmentsBarFormTitleInput, {}),
            /* @__PURE__ */ t(e.AttachmentsBarFormTitleError, {})
          ] }),
          /* @__PURE__ */ n(e.AttachmentsBarFormContent, { children: [
            /* @__PURE__ */ t(e.AttachmentsBarFormContentLabel, {}),
            /* @__PURE__ */ t(e.AttachmentsBarFormContentInput, {}),
            /* @__PURE__ */ t(e.AttachmentsBarFormContentError, {})
          ] }),
          /* @__PURE__ */ t(e.AttachmentsBarFormSubmitButton, {})
        ] }) })
      ] }) }) }) })
    ] })
  ] });
}
function E() {
  return /* @__PURE__ */ n(e.ActionBar, { children: [
    /* @__PURE__ */ n(e.TaglineContainer, { children: [
      /* @__PURE__ */ t(e.TaglineText, {}),
      /* @__PURE__ */ t(e.TaglineLogo, {}),
      /* @__PURE__ */ t(e.TaglineBrandName, {})
    ] }),
    /* @__PURE__ */ n(e.Actions, { children: [
      /* @__PURE__ */ t(e.HelpActions, { children: ({ pinned: a, unpinned: r }) => /* @__PURE__ */ n(l, { children: [
        a.map((c) => /* @__PURE__ */ t(e.HelpAction, { action: c }, c.name)),
        r.length > 0 && /* @__PURE__ */ t(e.HelpActionsTrigger, {}),
        /* @__PURE__ */ n(e.HelpActionsMenu, { children: [
          /* @__PURE__ */ t(e.HelpActionsMenuArrow, {}),
          r.map((c) => /* @__PURE__ */ n(e.HelpActionsMenuItem, { action: c, children: [
            /* @__PURE__ */ t(e.HelpActionsMenuItemIcon, { action: c }),
            c.name
          ] }, c.name))
        ] })
      ] }) }),
      /* @__PURE__ */ n(e.ChatAction, { action: "copy", children: [
        /* @__PURE__ */ t(e.ChatActionLabel, { action: "copy" }),
        /* @__PURE__ */ t(e.ChatActionFeedback, { action: "copy" })
      ] }),
      /* @__PURE__ */ n(e.ChatAction, { action: "share", children: [
        /* @__PURE__ */ t(e.ChatActionLabel, { action: "share" }),
        /* @__PURE__ */ t(e.ChatActionFeedback, { action: "share" })
      ] }),
      /* @__PURE__ */ t(e.ChatAction, { action: "clear" }),
      /* @__PURE__ */ t(e.ChatAction, { action: "stop" })
    ] })
  ] });
}
function W() {
  return /* @__PURE__ */ t(s, { children: /* @__PURE__ */ t(e.FeedbackModal, { children: /* @__PURE__ */ t(e.FeedbackModalOverlay, { children: /* @__PURE__ */ n(e.FeedbackModalContent, { children: [
    /* @__PURE__ */ t(e.FeedbackModalHeader, {}),
    /* @__PURE__ */ t(e.FeedbackModalClose, {}),
    /* @__PURE__ */ t(e.FeedbackModalBody, { children: /* @__PURE__ */ n(e.FeedbackForm, { children: [
      /* @__PURE__ */ n(e.FeedbackItem, { name: "unrelated_response", children: [
        /* @__PURE__ */ t(e.FeedbackItemCheckbox, { children: /* @__PURE__ */ t(e.FeedbackItemCheckboxIndicator, {}) }),
        /* @__PURE__ */ t(e.FeedbackItemLabel, {}),
        /* @__PURE__ */ t(e.FeedbackItemDescription, {})
      ] }),
      /* @__PURE__ */ n(e.FeedbackItem, { name: "inaccurate_statement", children: [
        /* @__PURE__ */ t(e.FeedbackItemCheckbox, { children: /* @__PURE__ */ t(e.FeedbackItemCheckboxIndicator, {}) }),
        /* @__PURE__ */ t(e.FeedbackItemLabel, {}),
        /* @__PURE__ */ t(e.FeedbackItemDescription, {})
      ] }),
      /* @__PURE__ */ n(e.FeedbackItem, { name: "inaccurate_code_snippet", children: [
        /* @__PURE__ */ t(e.FeedbackItemCheckbox, { children: /* @__PURE__ */ t(e.FeedbackItemCheckboxIndicator, {}) }),
        /* @__PURE__ */ t(e.FeedbackItemLabel, {}),
        /* @__PURE__ */ t(e.FeedbackItemDescription, {})
      ] }),
      /* @__PURE__ */ n(e.FeedbackItem, { name: "irrelevant_citations", children: [
        /* @__PURE__ */ t(e.FeedbackItemCheckbox, { children: /* @__PURE__ */ t(e.FeedbackItemCheckboxIndicator, {}) }),
        /* @__PURE__ */ t(e.FeedbackItemLabel, {})
      ] }),
      /* @__PURE__ */ t(e.FeedbackSubmitButton, {})
    ] }) })
  ] }) }) }) });
}
function P() {
  return /* @__PURE__ */ n(e.FormWrapper, { children: [
    /* @__PURE__ */ t(e.FormClose, {}),
    /* @__PURE__ */ n(e.Form, { children: [
      /* @__PURE__ */ n(e.FormHeader, { children: [
        /* @__PURE__ */ t(e.FormHeading, {}),
        /* @__PURE__ */ t(e.FormDescription, {})
      ] }),
      /* @__PURE__ */ t(e.FormContent, { children: (a) => /* @__PURE__ */ n(l, { children: [
        a.map((r, c) => /* @__PURE__ */ n(e.FormField, { field: r, autoFocus: c === 0, children: [
          /* @__PURE__ */ t(e.FormFieldLabel, {}),
          r.inputType === "text" && /* @__PURE__ */ t(e.FormFieldText, {}),
          r.inputType === "email" && /* @__PURE__ */ t(e.FormFieldEmail, {}),
          r.inputType === "file" && /* @__PURE__ */ t(e.FormFieldFile, {}),
          r.inputType === "textarea" && /* @__PURE__ */ t(e.FormFieldTextArea, {}),
          r.inputType === "checkbox" && /* @__PURE__ */ t(e.FormFieldCheckbox, { children: /* @__PURE__ */ t(e.FormFieldCheckboxIndicator, {}) }),
          r.inputType === "select" && /* @__PURE__ */ n(e.FormFieldSelect, { children: [
            /* @__PURE__ */ n(e.FormFieldSelectTrigger, { children: [
              /* @__PURE__ */ t(e.FormFieldSelectValue, {}),
              /* @__PURE__ */ t(e.FormFieldSelectIcon, {})
            ] }),
            /* @__PURE__ */ t(e.FormFieldSelectContent, { children: /* @__PURE__ */ t(e.FormFieldSelectViewport, { children: r.items.map((o) => /* @__PURE__ */ n(e.FormFieldSelectItem, { value: o.value, children: [
              /* @__PURE__ */ t(e.FormFieldSelectItemText, { children: o.label }),
              /* @__PURE__ */ t(e.FormFieldSelectItemIndicator, {})
            ] }, o.value)) }) })
          ] }),
          /* @__PURE__ */ t(e.FormFieldError, {})
        ] }, r.name)),
        /* @__PURE__ */ t(e.FormError, {})
      ] }) }),
      /* @__PURE__ */ n(e.FormFooter, { children: [
        /* @__PURE__ */ t(e.FormCancel, {}),
        /* @__PURE__ */ t(e.FormSubmit, {})
      ] })
    ] }),
    /* @__PURE__ */ n(e.FormSuccess, { children: [
      /* @__PURE__ */ t(e.FormSuccessHeading, {}),
      /* @__PURE__ */ t(e.FormSuccessMessage, {}),
      /* @__PURE__ */ t(e.FormSuccessButton, {})
    ] })
  ] });
}
export {
  $ as InkeepEmbeddedChat,
  k as InkeepEmbeddedChatImpl,
  T as InkeepEmbeddedChatImplContent,
  C as InkeepEmbeddedChatProvider
};
